



























































import { Component } from 'vue-property-decorator';
import PercentageStackedBarChart from '../chartjs/PercentageStackedBarChart.vue';
import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '../ChartError.vue';
import ChartLabels from '../ChartLabels.vue';
import { ReportType } from '../../models/reportType';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import BaseFlowReport from '@/features/reports/components/flows/baseFlowReport';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';

@Component({
	components: {
		BarChart,
		PercentageStackedBarChart,
		LineChart,
		LoadingSpinner,
		ChartError,
		ChartNoData,
		ChartLabels,
		FlowIcon,
		HelpIcon
	}
})
export default class FlowEscalationRateCharts extends BaseFlowReport {
	public reportId = ReportType.FLOW_ENGAGEMENT;
	public tooltipText = 'A trend showing the proportion of users who started a flow and subsequently engaged and completed the flow';
}
